import  gql  from 'graphql-tag'

export const CREATE_CREDIT_RATE = gql`mutation creditRate($input: CreditRateMutationInput!){
    creditRate(input: $input){
        creditRate{
            id
            data
        }
        errors{
            field
            messages
        }
    }
}`;